<template>
  <v-card class="bid-card">
    <v-card-title v-if="cardTitle" class="bid-card__title">
      {{ cardTitle }}
    </v-card-title>
    <v-card-text class="bid-card__content">
      <div v-if="loading" class="d-flex align-center justify-center h-full">
        <v-progress-circular indeterminate size="48" color="#18A1C8" />
      </div>
      <slot v-else />
    </v-card-text>
  </v-card>
</template>

<script setup lang="ts">
import { defineProps } from 'vue';

// #props
defineProps({
  cardTitle: {
    type: String,
    default: ''
  },
  loading: {
    type: Boolean,
    default: false
  }
});
</script>

<style scoped lang="scss">
@import '@/assets/style/_colors.scss';
.bid-card {
  &__title {
    border-radius: 8px 8px 0px 0px;
    font-size: 19px;
    font-style: normal;
    font-weight: 500;
    line-height: 32px;
    text-transform: uppercase;
    background: rgba($color-ui-blue-info, 0.1);
    padding: 12px 24px;
  }
  &__content {
    padding: 16px 24px !important;
  }
}
</style>
